export default __webpack_public_path__ + "static/assets/64e66a9dcf4b42a699f49e5973a4a62e.svg";